import { NavigationProp, StackActions, useNavigation } from '@react-navigation/native';
import React, { useEffect } from 'react';
import styled from 'styled-components/native';

import { Color } from '~/components/color';
import { isEidentCancellation } from '~/components/e-ident/e-ident-callback';
import { EIdentWeb, EIdentWebVerify, EIdentWebError } from '~/components/e-ident/e-ident.web';
import { AppNavigatorParamList } from '~/navigator/app-navigator';

type AuthVerifyNavigationProp = NavigationProp<AppNavigatorParamList, 'verify'>;
type AuthVerifyEidentNavigationProp = NavigationProp<AppNavigatorParamList, 'eident-verify'>;

const ScreenContainer = styled.View`
    flex: 1;
    background-color: ${Color.BACKGROUND_TERTIARY};
`;

export function AuthVerify() {
    return (
        <ScreenContainer>
            <EIdentWeb />
        </ScreenContainer>
    );
}

export function AuthVerifyEident() {
    const { navigate, dispatch } = useNavigation<AuthVerifyEidentNavigationProp>();
    const cancelled = isEidentCancellation(window.location.search);

    useEffect(() => {
        if (cancelled) {
            // Defer the dispatch past the current tick. The eident-verify mount is driven by the
            // linking config resolving the cancel URL, and dispatching synchronously inside the
            // mount effect gets silently dropped before the navigator has finished settling.
            const timer = setTimeout(() => {
                dispatch(StackActions.replace('authenticate'));
            }, 0);
            return () => clearTimeout(timer);
        }
    }, [cancelled, dispatch]);

    if (cancelled) {
        return <ScreenContainer />;
    }

    return (
        <ScreenContainer>
            <EIdentWebVerify
                onVerificationCompleted={result => (result.success ? result.commit() : navigate('eident-error'))}
            />
        </ScreenContainer>
    );
}

export function AuthVerifyEidentError() {
    const { navigate } = useNavigation<AuthVerifyNavigationProp>();

    return (
        <ScreenContainer>
            <EIdentWebError onRetry={() => navigate('verify')} />
        </ScreenContainer>
    );
}
